import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

import * as socketIo from 'socket.io-client';

@Injectable()
export class SocketService {
  private apiUrl = environment.apiSocketUrl;
  private socket;

  public initSocket(): void {
    this.socket = socketIo(this.apiUrl);
  }

  public send(socket, data): void {
    this.socket.emit(socket, data);
  }

  public onAcoesSaved(): Observable<any[]> {
    return new Observable<any[]>(observer => {
      this.socket.on('acoes saved', (data) => observer.next(data));
    });
  }

  public onAcoesRemoved(): Observable<any[]> {
    return new Observable<any[]>(observer => {
      this.socket.on('acoes removed', (data) => observer.next(data));
    });
  }

  public onRoom(): Observable<{}> {
    return new Observable<{}>(observer => {
      this.socket.on('room', (data) => observer.next(data));
    });
  }

  public onEvent(event): Observable<any> {
    return new Observable<{}>(observer => {
      this.socket.on(event, () => observer.next());
    });
  }
}

export enum Action {
  JOINED,
  LEFT,
  RENAME
}

export enum Event {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect'
}
